import i18n from '@/lib/i18n';
import { isLocalDevApi } from '@/lib/workerApi';

export function workerUnavailableMessage(): string {
  return i18n.t(
    isLocalDevApi() ? 'errors.workerUnavailable' : 'errors.workerUnavailableProduction'
  );
}

const WORKER_ERROR_MARKERS = [
  'FIREBASE_SERVICE_ACCOUNT_JSON',
  'sync-dev-vars',
  'firebaseconfigured',
  'not configured',
  'Expected property name',
  'Code generation from strings disallowed'
];

export function mapApiErrorMessage(raw: string): string {
  const lower = raw.toLowerCase();
  if (WORKER_ERROR_MARKERS.some((m) => lower.includes(m.toLowerCase()))) {
    return workerUnavailableMessage();
  }
  if (lower.includes('not found')) {
    return i18n.t('errors.unavailable');
  }
  if (
    lower.includes('firestore index building') ||
    lower.includes('requires an index') ||
    lower.includes('failed_precondition') ||
    lower.includes('failed-precondition')
  ) {
    return i18n.t('errors.firestoreIndex');
  }
  return raw;
}
